import React, { useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { useTranslation } from "react-i18next";
import { PiMapPinFill, PiPhoneFill } from "react-icons/pi";
import Logo from "../assets/logo.svg";
import { Link } from "react-router-dom";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";

export default function Header() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  // Все пункты меню в одном месте
  const menuItems = [
    { id: "about", label: "Обо мне" },
    { id: "content", label: "Услуги" },
    { id: "prices", label: "Цены" },
    { id: "contacts", label: "Контакты" },
  ];

  const scrollProps = {
    smooth: true,
    duration: 600,
    offset: -50,
    spy: true,
    activeClass: "text-accent", // можно оформить активный пункт
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-[#02080D] h-20 flex items-center z-50">
      <div className="container px-4 mx-auto flex items-center justify-between">
        {/* Лого */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src={Logo}
            alt="Логотип Лапшиной Ирины"
            className="pt-2"
            loading="lazy"
          />
        </Link>

        {/* Десктоп меню */}
        <nav className="hidden md:flex md:gap-[32px] lg:gap-[64px] items-center">
          {menuItems.map((item) => (
            <ScrollLink
              key={item.id}
              to={item.id}
              className="nav-link text1 cursor-pointer"
              {...scrollProps}
            >
              {item.label}
            </ScrollLink>
          ))}
        </nav>

        {/* Адрес + телефон */}
        <address className="not-italic hidden sm:flex flex-col items-start gap-2 text-sm">
          <div className="flex items-center gap-1">
            <PiMapPinFill size={18} />
            <span className="text1">{t("city")}</span>
          </div>
          <a
            href={`tel:${t("phone")}`}
            className="flex text1 items-center gap-1 hover:underline"
          >
            <PiPhoneFill size={18} />
            {t("phone")}

          </a>
        </address>

        {/* Кнопка мобильного меню */}

        <button className="md:hidden text1" onClick={() => setOpen(!open)}>
          {open ? <RiCloseLine size={32} /> : <RiMenu3Line size={32} />}
        </button>
      </div>
      {/* Мобильное меню */}
      {
        <div
          className={`absolute top-20 left-0 w-full bg-[#02080D] text-center
    transition-all duration-500  transform
    ${open ? "max-h-96 opacity-100" : "max-h-0 opacity-0 pointer-events-none"}`}
        >
          <div className="pb-4 flex flex-col space-y-3">
            {menuItems.map((item) => (
              <ScrollLink
                key={item.id}
                to={item.id}
                className="nav-link text1 cursor-pointer py-2"
                onClick={() => setOpen(false)}
                {...scrollProps}
              >
                {item.label}
              </ScrollLink>
            ))}
          </div>
        </div>
      }
    </header>
  );
}
